import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AttachmentErrorDialogComponent } from 'src/app/grievance/attachment-error-dialog/attachment-error-dialog.component';
import { CommonFunction } from 'src/app/grievance/common-function';
import { Status } from 'src/app/grievance/interface/common-interface';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { ViewattachmentComponent } from '../../../internal-user/viewattachment/viewattachment.component';
import { AssignedGrievanceViewReplyService } from './assigned-grievance-view-reply.service';
declare var require: any;

import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
const htmlToPdfmake = require("html-to-pdfmake");
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;


@Component({
  selector: 'app-assgined-grievance-view-reply',
  templateUrl: './assgined-grievance-view-reply.component.html',
  styleUrls: ['./assgined-grievance-view-reply.component.scss'],
})
export class AssginedGrievanceViewReplyComponent implements OnInit {
  myid: any;
  grievanceHistory = [];
  grievanceId: any;
  boardName: any;
  grievanceType: any;
  id: any;
  subject: any;
  remark: any;
  resstatus: any;
  document; any;
  createdOn: any;
  isShowReply: boolean = false;
  docType: string;
  userType: string;
  applicationName: any;
  lotteryName: any;
  paymentAmount: any;
  replyCtrl = new FormControl();
  documentList: any = []
  progressSpinnerDialog: any = null;

  fileWarningMsg1 = ProjectConstants.uiUploadMax3FilesMsg
  fileWarningMsg2 = ProjectConstants.uiFileExtensionMsg
  fileWarningMsg3 = ProjectConstants.uiFileSizeMsg

  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  @ViewChild('singleSelect') singleSelect: MatSelect;

  @ViewChild('attachments') attachments: any;
  @ViewChild('attachments1') attachments1: any;
  @ViewChild('attachments2') attachments2: any;
  isShowClose: boolean = false;
  isShowClose1: boolean = false;
  isShowClose2: boolean = false;

  filefirst: boolean = false;
  fileSecond: boolean = false;
  filethird: boolean = false;
  file: File = null;
  file1: File = null;
  file2: File = null;
  fileBase64: any;
  fileBase1_64: any;
  fileBase2_64: any;
  filenm: any;
  filenm1: any;
  filenm2: any;

  userId: any;
  userName: any;
  umobileNo: any;
  uemail: any;
  protected statuses: Status[] = [];
  protected _onDestroy = new Subject<void>();
  showReply: boolean = false
  isSubmitDisabled: boolean = false;
  firstFormGroup = this._formBuilder.group({
    statusCtrl: ['', [Validators.required]],
    replyCtrl: ['', [Validators.required]],
  })
  upan: any;
  constructor(public assignedGrievanceReplyService: AssignedGrievanceViewReplyService,
    public router: Router,
    public _formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    public commonFunction: CommonFunction,
    public dialog: MatDialog,
    public activatedRoute: ActivatedRoute) { }

  async ngOnInit() {
    this.showFile()
    //get id through activatedroute
    this.id = this.activatedRoute.snapshot.paramMap.get('myid');

    //load grievance history, statuses, auto scroll history
    this.loadGrievanceHistory();
    this.loadStatus();
    this.scrollToBottom();
    //
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  //auto scroll history
  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }
  //

  //on distroy
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
  //

  //load status 
  async loadStatus() {
    this.displayProgressSpinner();
    const response: any = await this.assignedGrievanceReplyService.loadStatus();
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.statuses = response
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-grievances")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-grievances")
    }
  }
  //

  @ViewChild('pdfTable')
  pdfTable!: ElementRef;
  exportPdf() {
    const pdfTable = this.pdfTable.nativeElement;
    var html = htmlToPdfmake(pdfTable.innerHTML);
    const documentDefinition = { content: html };
    pdfMake.createPdf(documentDefinition).download("Grievance History Report.pdf"); 
  }

  //load grievance history
  async loadGrievanceHistory() {
    const data = {
      "complaintId": this.id
    }
    // this.displayProgressSpinner();
    const response: any = await this.assignedGrievanceReplyService.loadGrievanceHistoryById(data);
    // this.progressSpinnerDialog.close()   
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        if (response.tabUserGrievance.length != 0) {
          var type;
          this.grievanceId = response.tabUserGrievance.pkUsgrid;
          this.boardName = response.tabUserGrievance.boardName;
          this.grievanceType = response.tabUserGrievance.grivType;
          this.subject = response.tabUserGrievance.usGriSubject;
          this.remark = response.tabUserGrievance.usGriDetails;
          this.createdOn = response.tabUserGrievance.createdOn;
          this.upan = response.tabUserGrievance.historyuserPanNo
          if (response.tabUserGrievance.internalUserId == null) {
            this.userId = response.tabUserGrievance.fkLotteryUserRegid
          } else {
            this.userId = response.tabUserGrievance.internalUserId
          }

        
          // this.userId=response.tabUserGrievance.
          this.userName=response.tabUserGrievance.historyuserName
          this.umobileNo= response.tabUserGrievance.historyuserMobileNo;
          // this.umobileNo= this.mask_mobile(response.tabUserGrievance.historyuserMobileNo);

          // this.uemail=this.mask_email(response.tabUserGrievance.historyuserEmail)
          this.uemail=response.tabUserGrievance.historyuserEmail

          // this.grievanceHistory = response.tabGrievanceHistory.sort((a, b) => a.pkGhid > b.pkGhid ? 1 : -1)
          this.grievanceHistory = response.tabGrievanceHistory.map((item) => {
            if (item.ghDocument1 != null) {
              item.ghDocument1 = item.ghDocument1
            }
            if (item.ghDocument2 != null) {
              item.ghDocument2 = item.ghDocument2
            }
            if (item.ghDocument3 != null) {
              item.ghDocument3 = item.ghDocument3
            }
            return item
          })
          this.resstatus = response.tabUserGrievance.statusName;
          this.applicationName = response.tabUserGrievance.applicationNo
          this.lotteryName = response.tabUserGrievance.lotteryName
          this.paymentAmount = response.tabUserGrievance.onlinePaymentName
          if (response.tabUserGrievance.usGriDocument1 != null) {
            this.documentList.push(response.tabUserGrievance.usGriDocument1)
          }
          if (response.tabUserGrievance.usGriDocument2 != null) {
            this.documentList.push(response.tabUserGrievance.usGriDocument2)
          }
          if (response.tabUserGrievance.usGriDocument3 != null) {
            this.documentList.push(response.tabUserGrievance.usGriDocument3)
          }
          if (response.tabUserGrievance.fkStid != 9 && response.tabUserGrievance.fkStid != 5 && response.tabUserGrievance.fkStid != 8) {
            this.showReply = true
          }
          type = response.tabUserGrievance.usGriUserType;
          if (type == "MU") {
            this.userType = ProjectConstants.userTypeMhadaUser
          } else if (type == "LU") {
            this.userType = ProjectConstants.userTypeLotteryUser
          }
        }
      } else if (response.status == ProjectConstants.responseStatusFailure) {
        if (response.code == ProjectConstants.authanticationFailedCode) {
          await this.commonFunction.errorToast(ProjectConstants.authanticationFailedMsg, true, "secure/assigned-grievances")
        }
      }
      else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-grievances")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-grievances")
    }
  }
  //


  mask_mobile(number) {
    let mask = ''
    if(number!=null){
      for (let i = 1; i <= number.length - 4; i++) {
        mask += '*'
      }
      number = mask + number.slice(6, 10);
  
      return number
    }else{
      return number
    }
   
  }
  // mask_email(mail) {
  //   if(mail!=null){
  //   const [name, domain] = mail.split('@');
  //   const { length: len } = name;
  //   const maskedName = name[0] + '****' + name[len - 1];
  //   const maskedEmail = maskedName + '@' + domain;
  //   return maskedEmail
  //   }else{
  //     return mail
  //   }
  // }

  // reply to assigned grievance
  async replyToCustomer() {
    if (this.firstFormGroup.valid) {
      if (this.filenm != null) {
        var file1_extension = '.' + this.filenm.split('.')[this.filenm.split('.').length - 1]
      }
      if (this.filenm1 != null) {
        var file2_extension = '.' + this.filenm1.split('.')[this.filenm1.split('.').length - 1]
      }
      if (this.filenm2 != null) {
        var file3_extension = '.' + this.filenm2.split('.')[this.filenm2.split('.').length - 1]
      }
      const data = {
        'ghRemark': this.firstFormGroup.controls['replyCtrl'].value,
        'fkUsGriid': this.id,
        'ghStatusId': this.firstFormGroup.controls['statusCtrl'].value,
        'file1': this.fileBase64,
        'file1Ext': file1_extension,
        'file2': this.fileBase1_64,
        'file2Ext': file2_extension,
        'file3': this.fileBase2_64,
        'file3Ext': file3_extension,
        'file1Name': this.filenm,
        'file2Name': this.filenm1,
        'file3Name': this.filenm2
      }
      this.displayProgressSpinner();
      const response: any = await this.assignedGrievanceReplyService.replyGrievance(data);
      this.progressSpinnerDialog.close()
      if (response != null && !response.error) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          await this.commonFunction.successToast(ProjectConstants.replySucessMsg, true, "secure/assigned-grievances")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-grievances")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-grievances")
      }
    }
  }
  //


  //after reply go to assigned grievance list
  gotoList() {
    this.router.navigate(['secure/assigned-grievances'])
  }
  //

  //view attached document when click on eye icon
  async ViewdownloadAttachment(ghDocument) {
    if (ghDocument.split(".")[1] == 'jpg' || ghDocument.split(".")[1] == 'jpeg' || ghDocument.split(".")[1] == 'png') {
      this.docType = "image/" + ghDocument.split(".")[1]
    } else if (ghDocument.split(".")[1] == 'pdf') {
      this.docType = "application/pdf"
    }
    this.displayProgressSpinner();
    const response: any = await this.assignedGrievanceReplyService.downloadAttachment(ghDocument);
    this.progressSpinnerDialog.close()

    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        const dialog = this.dialog.open(ViewattachmentComponent, {
          disableClose: true,
          width: "600px",
          data: [response.imgResponseString, this.id, this.docType, ghDocument]
        });
      } else if (response.status == ProjectConstants.responseStatusFailure) {
        if (response.code == ProjectConstants.noAbleToDownloadErCode) {
          await this.commonFunction.errorToast(ProjectConstants.noAbleToDownloadErMsg, false, "")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-grievances")
        }

      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-grievances")

    }
  }
  //
  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  //download attachment directly
  async downloadAttachment(ghDocument) {
    this.displayProgressSpinner();
    if (ghDocument.split(".")[1] == 'jpg' || ghDocument.split(".")[1] == 'jpeg' || ghDocument.split(".")[1] == 'png') {
      this.docType = "image/" + ghDocument.split(".")[1]
    } else if (ghDocument.split(".")[1] == 'pdf') {
      this.docType = "application/pdf"
    }
    const response: any = await this.assignedGrievanceReplyService.downloadAttachment(ghDocument);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        const byteArray = new Uint8Array(
          atob(response.imgResponseString)
            .split("")
            .map((char) => char.charCodeAt(0))
        );
        let blob = new Blob([byteArray], { type: this.docType });
        var src = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = src;
        const date = new Date().toDateString(),
          time = new Date().getTime()
        link.download = this.id + "_" + date + "_" + time +
          '.' + ghDocument.split('.').pop();
        link.click();
        // this.fileSuccessToast()
        await this.commonFunction.successToast(ProjectConstants.fileSuccessToastMsg, false, "")
      } else if (response.status == ProjectConstants.responseStatusFailure) {
        if (response.code == ProjectConstants.noAbleToDownloadErCode) {
          await this.commonFunction.errorToast(ProjectConstants.noAbleToDownloadErMsg, false, "")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-grievances")
        }
      }
      else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-grievances")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, true, "secure/assigned-grievances")
    }
  }
  //

  // remove upload
  removeAttachment() {
    if (this.file1 != null) {
      this.file = this.file1
      this.filenm = this.filenm1
      this.fileBase64 = this.fileBase1_64
      if (this.file2 != null) {
        this.file1 = this.file2
        this.filenm1 = this.filenm2
        this.fileBase1_64 = this.fileBase2_64
        this.isShowClose2 = false;
        this.file2 = null
        this.fileBase2_64 = null
        this.filenm2 = null
      } else {
        this.attachments.nativeElement.value = '';
        this.file1 = null
        this.fileBase1_64 = null
        this.filenm1 = null
        this.isShowClose1 = false;
      }
    } else {
      this.attachments.nativeElement.value = '';
      this.file = null
      this.fileBase64 = null
      this.filenm = null
      this.isShowClose = false;
    }
    this.showFile()
  }
  //

  // remove upload
  removeAttachment1() {
    if (this.file2 != null) {
      this.file1 = this.file2
      this.file2 = null
      this.fileBase1_64 = this.fileBase2_64
      this.fileBase2_64 = null
      this.filenm1 = this.filenm2
      this.filenm2 = null
      this.isShowClose2 = false;
    } else {
      this.attachments1.nativeElement.value = '';
      this.isShowClose1 = false;
      this.file1 = null
      this.filenm1 = null
      this.fileBase1_64 = null
    }
    this.showFile()
  }
  //

  // remove upload
  removeAttachment2() {
    this.attachments2.nativeElement.value = '';
    this.isShowClose2 = false;
    this.file2 = null
    this.filenm2 = null
    this.fileBase2_64 = null
    this.showFile()
  }
  //

  //file upload 1
  onChange(event) {
    this.file = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file == null) {
            this.isShowClose = false;
            this.filenm = ""
          } else {
            this.filenm = this.file.name
            this.isShowClose = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(this.file);
          }
        } else {
          this.file = null;
          this.isShowClose = false;
          this.filenm = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue },
          });
          event.target.value = "";
        }
        break;
      default:
        this.file = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse },
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file == null) {
            this.isShowClose = false;
          } else {
            this.isShowClose = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsBinaryString(this.file);
          }
        });
    }
  }
  //

  //file upload 2
  onChange1(event) {
    this.file1 = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':

        if (size <= ProjectConstants.maxFileSize) {
          if (this.file1 == null) {
            this.isShowClose1 = false;
            this.filenm1 = ""
          } else {
            this.filenm1 = this.file1.name
            this.isShowClose1 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(this.file1);
          }
        } else {
          this.file1 = null;
          this.isShowClose1 = false;
          this.filenm1 = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue },
          });
          event.target.value = "";
        }
        break;
      default:
        this.file1 = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse },
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file1 == null) {
            this.isShowClose1 = false;
          } else {
            this.isShowClose1 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded1.bind(this);
            reader.readAsBinaryString(this.file1);
          }
        });
    }
  }
  //

  //file upload
  onChange2(event) {
    this.file2 = event.target.files[0];
    var type = event.target.files[0].type;
    var size = event.target.files[0].size;
    var ext = type.split("/")[1];
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'pdf':
      case 'jpeg':
        if (size <= ProjectConstants.maxFileSize) {
          if (this.file2 == null) {
            this.isShowClose2 = false;
            this.filenm2 = ""
          } else {
            this.filenm2 = this.file2.name
            this.isShowClose2 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(this.file2);
          }
        } else {
          this.file2 = null;
          this.isShowClose2 = false;
          this.filenm2 = ""
          const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
            width: 'fit-content',
            data: { isSize: ProjectConstants.isSizeChecktrue },
          });
          event.target.value = "";
        }

        break;
      default:
        this.file2 = null;
        const dialogRef = this.dialog.open(AttachmentErrorDialogComponent, {
          width: 'fit-content',
          data: { isSize: ProjectConstants.isSizeCheckfalse },
        });
        dialogRef.afterClosed().subscribe(async result => {
          var returnval = result;
          event.target.value = "";
          if (this.file2 == null) {
            this.isShowClose2 = false;
          } else {
            this.isShowClose2 = true;
            this.showFile()
            var reader = new FileReader();
            reader.onload = this._handleReaderLoaded2.bind(this);
            reader.readAsBinaryString(this.file2);
          }
        });
    }
  }
  //

  //convert base64 file 1
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase64 = btoa(binaryString);
  }
  //

  //convert base64 file 2
  _handleReaderLoaded1(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase1_64 = btoa(binaryString);
  }
  //

  //convert base64 file 3
  _handleReaderLoaded2(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.fileBase2_64 = btoa(binaryString);
  }
  //

  //upload file 1 or 2 or 3
  showFile() {
    if (this.file == null && this.file1 == null && this.file2 == null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 == null && this.file2 != null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 != null && this.file2 == null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    } else if (this.file == null && this.file1 != null && this.file2 != null) {
      this.filefirst = true;
      this.fileSecond = false;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 == null && this.file2 == null) {
      this.filefirst = false;
      this.fileSecond = true;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 == null && this.file2 != null) {
      this.filefirst = false;
      this.fileSecond = true;
      this.filethird = false;
    }
    else if (this.file != null && this.file1 != null && this.file2 == null) {
      this.filefirst = false;
      this.fileSecond = false;
      this.filethird = true;
    }
    else if (this.file != null && this.file1 != null && this.file2 != null) {
      this.filefirst = false;
      this.fileSecond = false;
      this.filethird = false;
    }
  }
  //
}

